var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "competition-settings" },
    [
      !_vm.ready
        ? _c("div", { staticClass: "row mat32" }, [_vm._m(0)])
        : [
            _c(
              "div",
              { ref: "messages" },
              [
                _vm.successMessage
                  ? _c("panel-info-box", { staticClass: "mab16" }, [
                      _c("p", { staticClass: "text-lg" }, [
                        _c("b", [_vm._v(_vm._s(_vm.successMessage))]),
                      ]),
                    ])
                  : _vm._e(),
                _vm.errorMessage
                  ? _c("panel-info-box", { staticClass: "mab16" }, [
                      _c("p", { staticClass: "text-lg" }, [
                        _c("b", [_vm._v(_vm._s(_vm.errorMessage))]),
                      ]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _c("panel-competition-numbering-form", {
              attrs: {
                competition: _vm.competition,
                saving: _vm.saving,
                assigning: _vm.assigning,
              },
              on: { save: _vm.saveSettings, assign: _vm.startAssign },
              model: {
                value: _vm.form,
                callback: function ($$v) {
                  _vm.form = $$v
                },
                expression: "form",
              },
            }),
          ],
      _c("modal", {
        ref: "previewModal",
        attrs: { size: "xl", "body-class": "h-auto" },
        on: { "modal-close": _vm.onPreviewClose },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c("h3", { staticClass: "preview-modal__title" }, [
                  _vm._v("Podgląd numeracji"),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _vm.simulating
                  ? _c("div", { staticClass: "preview-modal__loading" }, [
                      _vm._v("Trwa symulacja numeracji…"),
                    ])
                  : _vm.simulation
                  ? [
                      _vm.simulation.errors && _vm.simulation.errors.length
                        ? _c(
                            "div",
                            { staticClass: "preview-modal__errors" },
                            _vm._l(_vm.simulation.errors, function (err, i) {
                              return _c("p", { key: `e-${i}` }, [
                                _vm._v(_vm._s(err)),
                              ])
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm.simulation.warnings && _vm.simulation.warnings.length
                        ? _c(
                            "div",
                            { staticClass: "preview-modal__warnings" },
                            _vm._l(_vm.simulation.warnings, function (warn, i) {
                              return _c("p", { key: `w-${i}` }, [
                                _vm._v(_vm._s(warn)),
                              ])
                            }),
                            0
                          )
                        : _vm._e(),
                      _c("p", { staticClass: "preview-modal__summary" }, [
                        _vm._v(
                          " Przypisań: " +
                            _vm._s(
                              _vm.simulation.numbers
                                ? _vm.simulation.numbers.length
                                : 0
                            ) +
                            " "
                        ),
                        _vm.simulation.noProblems
                          ? _c("span", [_vm._v(" — brak problemów")])
                          : _vm._e(),
                      ]),
                      _c("div", { staticClass: "preview-modal__table-wrap" }, [
                        _c("table", { staticClass: "preview-modal__table" }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [_vm._v("Zawodnik")]),
                              _c("th", [_vm._v("Klasyfikacja")]),
                              _c("th", [_vm._v("Obecny")]),
                              _c("th", [_vm._v("Nowy")]),
                              _c("th", [_vm._v("Typ")]),
                              _c("th", [_vm._v("Uwagi")]),
                            ]),
                          ]),
                          _c(
                            "tbody",
                            _vm._l(
                              _vm.simulation.numbers || [],
                              function (row) {
                                return _c("tr", { key: row.playerId }, [
                                  _c("td", [
                                    _vm._v(_vm._s(_vm.playerLabel(row))),
                                  ]),
                                  _c("td", [
                                    _vm._v(_vm._s(row.classificationName)),
                                  ]),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumber(row.currentNumber)
                                      )
                                    ),
                                  ]),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumber(row.assignedNumber)
                                      )
                                    ),
                                  ]),
                                  _c("td", [
                                    _vm._v(_vm._s(_vm.typeLabel(row.type))),
                                  ]),
                                  _c("td", [_vm._v(_vm._s(_vm.rowNotes(row)))]),
                                ])
                              }
                            ),
                            0
                          ),
                        ]),
                      ]),
                    ]
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "preview-modal__footer" },
                  [
                    _c(
                      "base-button",
                      {
                        attrs: { btn2: "", disabled: _vm.confirming },
                        on: { click: _vm.closePreview },
                      },
                      [_vm._v("Anuluj")]
                    ),
                    _c(
                      "base-button",
                      {
                        attrs: {
                          btn1: "",
                          loading: _vm.confirming,
                          disabled: _vm.confirming || !_vm.canConfirmAssign,
                        },
                        on: { click: _vm.confirmAssign },
                      },
                      [_vm._v(" Potwierdź nadanie ")]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "admin-header__loading-state" }, [
        _vm._v(" Trwa wczytywanie "),
        _c("div", { staticClass: "mal15 lds-ellipsis" }, [
          _c("div"),
          _c("div"),
          _c("div"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }